import { useQuery } from "hooks/useQuery";
import { getStockMetrics } from "../service";

export const useStockMetrics = (symbol) => {
  const { isLoading, data, error } = useQuery({
    queryKey: ["stockMetrics", symbol],
    queryFn: async () => {
      const response = await getStockMetrics(symbol);
      return response;
    },
    enabled: Boolean(symbol),
  });

  return {
    isLoading,
    stockDetails: data || {},
    error,
  };
};
